import styled from "styled-components";
import {
  primaryColor,
  primaryHoverColor,
  primaryActiveColor,
  secondaryColor,
  secondaryHoverColor,
  secondaryActiveColor,
  newsecondaryColor,
  newsecondaryHoverColor,
  newsecondaryActiveColor,
  whiteColor,
  whiteHoverColor,
  whiteActiveColor,
  screenSize,
  defaultColor,
  defaultHoverColor,
  defaultActiveColor,
  blackColor,
  dangerColor,
  labelColor,
  semiBoldFont,
  mediumFont
} from "@app/styles";

type ButtonProps = {
  variant?:
  | "primary"
  | "secondary"
  | "newsecondary"
  | "text"
  | "google"
  | "default"
  | "cancel"
  | "danger"
  | "bordered";
  size?: "small" | "medium" | "large";
  width?: string;
  height?: string;
};

export const ButtonContainer = styled.button`
  height: 50px;
  min-width: 120px;
  padding: 0 24px;
  border: 1px solid transparent;
  font-size: 16px;
  font-family: "Poppins", sans-serif !important;
  border-radius: 8px;
  outline: none;
  cursor: pointer;
  color: #08283e;
  ${mediumFont};
  display: flex;
  align-items: center;
  justify-content: center;
  &.icon-btn{
    font-size: 18px;
  }
  ${({ width }: ButtonProps) => {
    if (width) {
      return `width: ${width}; min-width: unset;`;
    }
  }}
  ${({ height }: ButtonProps) => {
    if (height) {
      return `height: ${height} !important;`;
    }
  }}
  ${({ size }: ButtonProps) => {
    if (size === "large") {
      return `
                height: 50px;
            `;
    } else if (size === "medium") {
      return `
                height: 40px;
            `;
    } else if (size === "small") {
      return `
                height: 32px;
            `;
    }
  }}
    ${({ variant }: ButtonProps) => {
    if (variant === "primary") {
      return `
                background-color: ${primaryColor};
                color: ${whiteColor};
                &:hover {
                    background-color: ${primaryHoverColor};
                }
                &:active {
                    background-color: ${primaryActiveColor};
                }
            `;
    } else if (variant === "default") {
      return `
                background-color: ${defaultColor};
                // color: ${blackColor};
                &:hover {
                    background-color: ${defaultHoverColor};
                }
                &:active {
                    background-color: ${defaultActiveColor};
                }
            `;
    } else if (variant === "secondary") {
      return `
                background-color: ${secondaryColor};
                color: ${whiteColor};
                &:hover {
                    background-color: ${secondaryHoverColor};
                }
                &:active {
                    background-color: ${secondaryActiveColor};
                }
            `;
    } else if (variant === "newsecondary") {
      return `
                background-color: ${newsecondaryColor};
                color:  ${whiteColor};
                &:hover {
                    background-color: ${newsecondaryHoverColor};
                }
                &:active {
                    background-color: ${newsecondaryActiveColor};
                }
            `;
    } else if (variant === "cancel") {
      return `
                background-color: ${whiteColor};
                color: ${newsecondaryColor};
            `;
    } else if (variant === "bordered") {
      return `
      border-color: ${newsecondaryColor};
                color: ${newsecondaryColor};
                background:  ${whiteColor};
            `;
    } else if (variant === "danger") {
      return `
                background-color: ${dangerColor};
                color: ${whiteColor};
            `;
    } else if (variant === "text") {
      return `
                background-color: ${whiteColor};
                color: ${labelColor};
                &:hover {
                    background-color: ${whiteHoverColor};
                }
                &:active {
                    background-color: ${whiteActiveColor};
                }
            `;
    } else if (variant === "google") {
      return `
                background-color: ${whiteColor};
                box-shadow: 0 0 1px rgba(0, 0, 0, 0.12), 0 1px 1px rgba(0, 0, 0, 0.24);
                font-family: 'Roboto', san-serif;
                font-size: 0.9rem;
                color: rgba(0, 0, 0, 0.54);
                &:hover {
                    background-color: ${whiteHoverColor};
                }
                &:active {
                    background-color: ${whiteActiveColor};
                }
                @media (${screenSize.tablet}){
                    border:1px solid rgba(150, 150, 150, 0.2);
                }
            `;
    }
  }}
  @media (max-width: 575px){
    width: 100%;
    padding: 0 16px;
    &.w-unset{
      width: unset !important;
    }
  }
`;
